import type { SystemDef, SystemModule } from "../integration";
import { SystemGlyph } from "../icons";

export default function SystemCard({
  system,
  onOpen,
}: {
  system: SystemDef;
  onOpen: (s: SystemDef, module?: SystemModule) => void;
}) {
  return (
    <div className="sys">
      <button
        className="sys-head"
        onClick={() => onOpen(system)}
        title={`Abrir ${system.nome}`}
      >
        <div className="sys-icon">
          <SystemGlyph name={system.icon} />
        </div>
        <div className="sys-title">
          <h3>{system.nome}</h3>
          <span className="sys-count">{system.modules.length} módulos</span>
        </div>
        <p>{system.descricao}</p>
      </button>

      <div className="sys-modules">
        {system.modules.map((m) => (
          <button
            key={m.key}
            className="chip"
            onClick={() => onOpen(system, m)}
            title={`Abrir ${system.nome} · ${m.label}`}
          >
            {m.label}
          </button>
        ))}
      </div>

      <button className="sys-go-btn" onClick={() => onOpen(system)}>
        <span>Abrir {system.nome}</span>
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      </button>
    </div>
  );
}
